import React from 'react'
import { Text } from '@ui'
import type { TextProps } from 'ui/components/Text/Text'

import * as styles from './EmojiSpan.css'

export interface EmojiSpanProps extends Omit<TextProps, 'children'> {
    emoji: string
    children?: React.ReactNode
}

/**
 * Consistent wrapper for all emoji rendering throughout the application.
 * Ensures all emojis are wrapped in a span with the "emoji" className for styling.
 */
export const EmojiSpan = ({ emoji, children, className, ...props }: EmojiSpanProps) => {
    const mergedClassName = [styles.emoji, className].filter(Boolean).join(' ')

    return (
        <Text as="span" className={mergedClassName} display="inline-block" {...props}>
            {emoji}
            {children}
        </Text>
    )
}
